import {
  Avatar,
  Button,
  CircularProgress,
  TextareaAutosize,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
} from "@material-ui/core";
import React, { Component } from "react";
import { FaAngleLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { _newContentReply, _newReply } from "./Utils";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from '@material-ui/core/IconButton';
import UserDisplay from "../../util/UserDisplay";
import DateTimeRenderer from "../../util/cell-renderer/DateTimeRenderer";
import * as realTimeSubscription from "../../data-services/realTimeSubscription";
import { localRefreshTrackingMetaInbox } from "../../util/LocalRefreshlocalRefreshTrackingMeta";
import { attachmentTypes, messageTypes, contentRequestTypes, contRequestTypesList, contentRequestStatusList, contentRequestStatus, contentRequestPriorityList, contentRequestPrposedUsageList, contentRequestNotSourceReasonsList } from "./Const";
// import trackFields from "../../_module/definition/trackFields";
import { Translation } from "react-i18next";
import { _PermittedContent } from "../../_module/utils/PermittedContent";
import { groupOrgStatus, recipientGroupType, userOrgStatus, defaultGroups } from "../../redux/Types";
import { FaCheckCircle } from "react-icons/fa";
import PermittedContent from "_module/component/permitted-content/PermittedContent";
import { AuthSrc } from './../../util/AuthSrc';
import { deepCopyFunction, getUserNameWithDetails } from "util/CommonFunc";
import CfSharePermission from "../ml-licensing/ClearanceForms/CfSharePermission";
import { appConfig } from "App";
export default class Compose extends Component {

  messageSubscripition;
  messageGroupSubscripitions = [];
  initialized = false;
  loadingMessage = false;
  containerEle;
  toolWrapper;
  composeWrapper;

  constructor(props) {
    super();

    const {
      inbox: {
        allUsers,
        allGroups,
      },
      user: cUser
    } = props;

    let recipients = [];
    
    if(allUsers && allUsers.length){
      recipients = allUsers.filter((user)=> {return (user.status === userOrgStatus.ACTIVE && user.userId !== cUser.id)}).map((user)=>{
        return {groupingType: recipientGroupType.USER, ...user};
      });
    }
  
    if(allGroups && allGroups.length){
      recipients = recipients.concat(allGroups.filter((group)=> {return group.status === groupOrgStatus.ACTIVE}).map((group)=>{
        return {groupingType: recipientGroupType.GROUP, ...group};
      }))
    }

    this.state = {
      realTimeUpdateSubscribed: false,
      messageWrapperHeight : 0,
      recipients: recipients,
      messageSent:false,
      recipientField:"",
      replyRecipientField:"",
      openCFSharePermissiomPopup: false,
      openCfDropError: false,
      cfDropErrorMsg: '',
      sendingWithNoCfPermission: false,
    };
  }
  
  componentDidMount() {
    const {
      messages: {
        editing,
      },
    } = this.props;

      if (editing.id) {
        if(this.getUserGroups(editing).length > 0){
          this.subscribeToRealTimeUpdateGroups(editing.id)
        }else{
          this.subscribeToRealTimeUpdate(editing.id);
        }
      }
  }

  componentDidUpdate(prevProps) {
    const {
      messages: {
        editing,
      },
    } = this.props;
 
    if(editing.id && !editing.subject && !editing.body && !this.loadingMessage){
      this.initialized = false;
      if(this.messageSubscripition){
        this.messageSubscripition();
      } 

      if(this.messageGroupSubscripitions.length){
        this.messageGroupSubscripitions.forEach(mSubscripition => {
          mSubscripition();
        });
        this.messageGroupSubscripitions = [];
      }
      
      if(this.getUserGroups(editing).length > 0){        
        this.subscribeToRealTimeUpdateGroups(editing.id)
      }else{
        this.subscribeToRealTimeUpdate(editing.id);
      }
    }
  }

  componentWillUnmount() {
    if(this.messageSubscripition) this.messageSubscripition();
    if(this.messageGroupSubscripitions.length){
      this.messageGroupSubscripitions.forEach(mSubscripition => {
        mSubscripition();
      });
    }
  };

  subscribeToRealTimeUpdate(messageID) {
    try {
      this.loadingMessage = true;
      this.messageSubscripition =  realTimeSubscription.subscribe({ userId: this.props.user.email.trim(), type:"user", topic: realTimeSubscription.Topics.MESSAGE + messageID }, this.loadMessage);
      this.setState({ realTimeUpdateSubscribed: true });
    }
    catch (error) {
      this.loadingMessage = false;
      this.setState({ realTimeUpdateSubscribed: false });
      console.log(error);
    };
  }

  subscribeToRealTimeUpdateGroups(messageID) {
    const {  messages: { editing, },  } = this.props;
    let groupsList = this.getUserGroups(editing);

    if(groupsList.length > 0){
      try {
        this.loadingMessage = true;
        this.messageGroupSubscripitions = [realTimeSubscription.subscribe({ 
            groupId: groupsList[0], type:"group", topic: realTimeSubscription.Topics.MESSAGE + messageID }, 
            this.loadMessage
            )]
      } catch (error) {
        this.loadingMessage = false;
          console.log(error);
      }
    }
  }

  getUserGroups(message){
    const { 
      user, 
      user: {
        credentials: {
          orgID
        }
      }
    } = this.props;

    let groupsToSub = [];

    if(user?.credentials?.orgs[0]?.groups?.length){
      let userGroups = user?.credentials?.orgs.find(o => o.id === orgID)?.groups ?? [];
      if (userGroups?.length > 0) {
        let toGroups = message?.togroups || [];
        groupsToSub = userGroups.filter(g => toGroups.includes(g));
      }
    }
    return groupsToSub;
  }


  loadMessage =() =>{
    const {
      postMessage,
      editMessage,
      messages: {
        editing,
      },
    } = this.props;

    if(!editing){
      this.initialized = false;
      return;
    }
      if (!this.initialized) {
        // load existing message
        this.initialized = true;
        if (!editing.subject && !editing.body) {
          postMessage("load", "", { message: editing }, (data, error) => {
            if (data) {             
              this.loadingMessage = false;
              if(editing?.type === messageTypes.CONTENT_REQUEST){
                data.newChildren = _newContentReply(data, "",editing?.attachments, editing?.linkedId);
              }else{
                data.newChildren = _newReply(data, "");
              }
              editMessage(data);
              this.setState({messageWrapperHeight : this.calcHeight()});              
              this.containerEle.scrollTop = this.containerEle.scrollHeight;
              // if(!this.messageGroupSubscripitions.length && this.getUserGroups().length > 0)
              //   this.subscribeToRealTimeUpdateGroups(editing.id);
            }
          });
        }
      } else {
        // load newly sent message
          postMessage("load", "", { message: editing }, (data, error) => {
            if (data) {
              this.loadingMessage = false;
              editing.children = [...data.children];
              editMessage(editing);
              this.containerEle.scrollTop = this.containerEle.scrollHeight;
              if(!this.messageGroupSubscripitions.length)
                this.subscribeToRealTimeUpdateGroups(editing.id);
            }
          });
      }

  }

  renderAttachment(canRemove = false, attachments = [], focusOnTab = true) {
    const {
      classes,
      messages: { editing,permittedOrgs },
      user: { id: userid, orgId, email },
    } = this.props;

    if(!attachments.length){
      attachments = editing.attachments;
    }

    const getPriorityText = (priority) => {
        let index = contentRequestPriorityList.findIndex(v => v.id === priority);
        let text =""
        if(index !== -1){
          text = `${contentRequestPriorityList[index]?.label}`
        }
        return text;
    }

    return (
      <>
        {attachments.map(
          (obj, i) =>
          ({
            1: (
              <div key={i}  style={i === (attachments.length - 1) ? {borderBottom: "none", marginBottom:"0", paddingBottom:"0"} : {borderBottom: "1px solid #474747"}}>
                 {/* <Link tabIndex={focusOnTab ? 0 : -1} to={`/mllicensingforms/${obj.id}`}> */}
                 <Link tabIndex={focusOnTab ? 0 : -1} href="#" onClick={(e)=>this.navToLink(e, `/mllicensingforms/${obj.id}`, true)}>
                <Avatar
                  alt={obj.name}
                  className={classes.trackAvatar}
                  variant="square"
                  src={AuthSrc(obj.artwork)}
                />
             
                  <span  className={classes.composeTrackName}>
                    {" "}
                    {obj.name}
                    <span className={classes.composeTracksCount}>
                      ({obj.tracksCount})
                      </span>{" "}
                  </span>{" "}
                </Link>
               {canRemove && 
                 <IconButton tabIndex={0}  aria-label="remove attachment" className={classes.composeRemoveItem} size="small"  onClick={(e) => { this.removeAttachment(i); }}                              
                  onKeyDown={(event) => event.key == 'Enter' ? this.removeAttachment(i) : null }>
                  <CloseIcon />
                </IconButton>
                
                } 
               

              </div>
            ),
            2: (
              <div key={i} style={i === (attachments.length - 1) ? {borderBottom: "none", marginBottom:"0", paddingBottom:"0"} : {borderBottom: "1px solid #474747"}}>
                {/* <Link tabIndex={focusOnTab ? 0 : -1} to={`/mllicensingforms/${obj.cfid}/${obj.id}`} onClick={(e)=>this.navToLink(e, `/mllicensingforms/${obj.cfid}/${obj.id}`)}> */}
                <Link tabIndex={focusOnTab ? 0 : -1} href="#" onClick={(e)=>this.navToLink(e, `/mllicensingforms/${obj.cfid}/${obj.id}`)}>
                  <Avatar
                  alt={obj.title}
                  className={classes.trackAvatar}
                  variant="square"
                  src={AuthSrc(obj.artwork)}
                />
                
                  <span  className={classes.composeTrackName}>
                    {obj.cfname + ", " + obj.title}
                    <span className={classes.composeArtist}>
                      {obj.artist}
                    </span>
                  </span>{" "}
                </Link>
                {canRemove && 
                 <IconButton tabIndex={0}  aria-label="remove attachment" className={classes.composeRemoveItem} size="small"  onClick={(e) => { this.removeAttachment(i); }}                              
                  onKeyDown={(event) => event.key == 'Enter' ? this.removeAttachment(i) : null }>
                  <CloseIcon />
                </IconButton>
                          
                } 
              </div>
            ),

            3: (
              <div key={i} style={i === (attachments.length - 1) ? {borderBottom: "none", marginBottom:"0", paddingBottom:"0"} : {borderBottom: "1px solid #474747"}}>
                <Link tabIndex={focusOnTab ? 0 : -1} to={`/search/tracks/${obj.id}`} key={obj.id}>
                  <Avatar
                    alt={obj.title}
                    className={classes.trackAvatar}
                    variant="square"
                    src={AuthSrc(obj.artwork)}
                  />
                  <span  className={classes.composeTrackName}>
                    {obj.title}
                    <span className={classes.composeArtist}>{obj.artist}</span>
                  </span>
                </Link>
                {canRemove && 
                  <IconButton tabIndex={0}  aria-label="remove attachment" className={classes.composeRemoveItem} size="small"  onClick={(e) => { this.removeAttachment(i); }}                              
                    onKeyDown={(event) => event.key == 'Enter' ? this.removeAttachment(i) : null }>
                    <CloseIcon />
                  </IconButton>
                  
                  }  
              </div>
            ),
            4: (
              <div key={i} style={i === (attachments.length - 1) ? {borderBottom: "none", marginBottom:"0", paddingBottom:"0"} : {borderBottom: "1px solid #474747"}}>
              {/* <Link tabIndex={focusOnTab ? 0 : -1} to={`/playlist/${obj.id}`}>
                  <Avatar
                  alt={obj.name}
                  className={classes.trackAvatar}
                  variant="square"
                  src={AuthSrc(obj.artwork)}
                />
                
                  <span className={classes.composeTrackName}>
                    {" "}
                    {obj.name}
                    <span className={classes.composeTracksCount}>
                      ({obj.tracksCount})
                      </span>{" "}
                  </span>{" "}
                </Link> */}


                {
                  (editing.type === messageTypes.PLAYLIST 
                    && attachments?.length > 0 
                    && attachments[0]?.sharedDetails
                    && attachments[0]?.sharedDetails?.sharedOrgId !== orgId
                    && permittedOrgs 
                    && permittedOrgs[attachments[0]?.sharedDetails?.sharedOrgId]
                    && permittedOrgs[attachments[0]?.sharedDetails?.sharedOrgId].userStatus === userOrgStatus.ACTIVE)
                    ?
                    <a  
                      href={this.getPlayListLink(attachments)} 
                      onClick={(event) =>
                        event.stopPropagation()
                      }
                    > 
                    <Avatar
                      alt={obj.name}
                      className={classes.trackAvatar}
                      variant="square"
                      src={AuthSrc(obj.artwork)}
                    />
                    <span className={classes.composeTrackName}>
                        {" "}
                        {obj.name}
                        <span className={classes.composeTracksCount}>
                          ({obj.tracksCount})
                          </span>{" "}
                      </span>{" "}
                    
                    </a>

                    :

                    editing.type === messageTypes.PLAYLIST 
                    && attachments?.length > 0 
                    && (editing.createdBy === email || attachments[0]?.sharedDetails?.sharedOrgId === orgId)
                    
                    ?

                    <Link tabIndex={focusOnTab ? 0 : -1} to={this.getPlayListLink(attachments)}>
                      <Avatar
                      alt={obj.name}
                      className={classes.trackAvatar}
                      variant="square"
                      src={AuthSrc(obj.artwork)}
                    />
                    
                      <span className={classes.composeTrackName}>
                        {" "}
                        {obj.name}
                        <span className={classes.composeTracksCount}>
                          ({obj.tracksCount})
                          </span>{" "}
                      </span>{" "}
                    </Link>
                    :
                    
                    <Link tabIndex={focusOnTab ? 0 : -1} to={this.getPlayListLink(attachments)}>
                      <Avatar
                      alt={obj.name}
                      className={classes.trackAvatar}
                      variant="square"
                      src={AuthSrc(obj.artwork)}
                    />
                    
                      <span className={classes.composeTrackName}>
                        {" "}
                        {obj.name}
                        <span className={classes.composeTracksCount}>
                          ({obj.tracksCount})
                          </span>{" "}
                      </span>{" "}
                    </Link>
                }



                {canRemove && 
                 <IconButton tabIndex={0}  aria-label="remove attachment" className={classes.composeRemoveItem} size="small"  onClick={(e) => { this.removeAttachment(i); }}                              
                  onKeyDown={(event) => event.key == 'Enter' ? this.removeAttachment(i) : null }>
                  <CloseIcon />
                </IconButton>
                
                } 
              </div>
            ),
            5: (
              <div key={i} style={i === (attachments.length - 1) ? {borderBottom: "none", marginBottom:"0", paddingBottom:"0"} : {borderBottom: "1px solid #474747"}}>
                {/* <Link tabIndex={focusOnTab ? 0 : -1} to={`/mllicensingforms/${obj.cfid}/${obj.id}`} onClick={(e)=>this.navToLink(e, `/mllicensingforms/${obj.cfid}/${obj.id}`)}> */}
                <Link tabIndex={focusOnTab ? 0 : -1} href="#" onClick={(e)=>this.navToLink(e, `/mllicensingforms/${obj.cfid}/${obj.id}`)}>
                  <Avatar
                  alt={obj.title}
                  className={classes.trackAvatar}
                  variant="square"
                  src={obj.artwork || process.env.PUBLIC_URL + '/artwork.png'}
                />
                
                  <span  className={classes.composeTrackName}>
                    {obj.cfname + ", " + obj.title}
                    <span className={classes.composeArtist}>
                      {obj.artist}
                    </span>
                  </span>{" "}
                </Link>
                {canRemove && 
                 <IconButton tabIndex={0}  aria-label="remove attachment" className={classes.composeRemoveItem} size="small"  onClick={(e) => { this.removeAttachment(i); }}                              
                  onKeyDown={(event) => event.key == 'Enter' ? this.removeAttachment(i) : null }>
                  <CloseIcon />
                </IconButton>
                          
                } 
              </div>
            ),
            6: (
              <div key={i} style={i === (attachments.length - 1) ? {borderBottom: "none",display:"block", marginBottom:"0", paddingBottom:"0"} : {borderBottom: "1px solid #474747"}}>
                {obj.contentType !== contentRequestTypes.ALBUM && ( 
                  <>
                   <div className={classes.contentMessageAttachments}>
                <span  className={classes.composeTrackName}>
                TRACK TITLE : {obj.title}
                    <span className={classes.composeArtist}>Artist : {obj.artist}</span>
                  </span>
                  
                  {/* <hr className={classes.horizantalBorder} />
                  <span  className={classes.composeTrackName}>
                  ALBUM TITLE : {obj.album}
                  <span className={classes.composeArtist}>Catalog # : {obj.catNumber}</span>
                </span> */}
               </div>
                </>
                  )}
                  {obj.contentType === contentRequestTypes.ALBUM && ( 
                  <>
                  <div className={classes.contentMessageAttachments}>
                <span  className={classes.composeTrackName}>
                ALBUM TITLE : {obj.title}
                    <span className={classes.composeArtist}>Artist : {obj.artist}</span>
                    <span className={classes.composeArtist}>Catalog # : {obj.catNumber}</span>
                </span>
                </div>
                </>
                  )}

                <hr className={classes.horizantalBorder} />
                <div className={classes.contentMessageAttachments}>
                <span  className={classes.composeTrackName}>
                  TYPE : {obj.contentType ? contRequestTypesList[contRequestTypesList.findIndex(v => v.id === obj.contentType)]?.label : ""}
                </span>
                </div>

                <hr className={classes.horizantalBorder} />
                <div className={classes.contentMessageAttachments}>
                <span  className={classes.composeTrackName}>
                  PROPOSED USAGE : {obj.proposedUsage ? contentRequestPrposedUsageList[contentRequestPrposedUsageList.findIndex(v => v.id === obj.proposedUsage)]?.label : ""}
                </span>
                </div>

                <hr className={classes.horizantalBorder} />
                <div className={classes.contentMessageAttachments}>
                <span  className={classes.composeTrackName}>
                  PRIORITY LEVEL : {getPriorityText(obj.priority)}
                </span>
                </div>
              
              </div>
            ),
            7: ( //ALBUMS
              <div key={i} style={i === (attachments.length - 1) ? {borderBottom: "none", marginBottom:"0", paddingBottom:"0"} : {borderBottom: "1px solid #474747"}}>
                <Link tabIndex={focusOnTab ? 0 : -1} to={`/search/album/${obj.id}`} key={obj.id}>
                  <Avatar
                    alt={obj.title}
                    className={classes.trackAvatar}
                    variant="square"
                    src={AuthSrc(obj.artwork)}
                  />
                  <span  className={classes.composeTrackName}>
                    {obj.title}
                    <span className={classes.composeArtist}>{obj.artist}</span>
                  </span>
                </Link>
                {canRemove && 
                  <IconButton tabIndex={0}  aria-label="remove attachment" className={classes.composeRemoveItem} size="small"  onClick={(e) => { this.removeAttachment(i); }}                              
                    onKeyDown={(event) => event.key == 'Enter' ? this.removeAttachment(i) : null }>
                    <CloseIcon />
                  </IconButton>
                  }  
              </div>
            ),
          }[attachments[i].type ? attachments[i].type : editing.type]
          )
        )}
      </>
    );
  }

  getPlayListLink =(attachments) =>{
    const {
      user: { id: userid, orgId },
      user,
    } = this.props;

    let link = ""

    if(attachments[0]?.sharedDetails?.sharedOrgId && attachments[0]?.sharedDetails?.sharedOrgId !== orgId){
      link= "https://" + attachments[0]?.sharedDetails?.sharedOrgId + "." +
                                  appConfig.MB_DOMAIN + "/tourl?url=/playlist/"+ attachments[0]?.id +"&origin=" +
                                  orgId + "." +
                                  appConfig.MB_DOMAIN +
                                  "&org=" +
                                  encodeURIComponent(btoa(attachments[0]?.sharedDetails?.sharedOrgId)) +
                                  "&user=" +
                                  encodeURIComponent(btoa(user.email))
    }else{
      link = `/playlist/${attachments[0]?.id}`;
    }

    return link;
  }

  navToLink(e, link, form = false){
    const {location : { pathname }} = this.props;
    
    e.preventDefault();
    if(pathname.indexOf(!form?link.slice(0, link.lastIndexOf('/')):link) != -1) return;

    this.props.history.push(link);
  }

 
  removeAttachment = (index, count = 1)=>{
    const {
      editMessage,
      messages: { editing },
    } = this.props;

    if(editing.id){
      editing.newChildren.attachments.splice(index, count);
    }else{
      editing.attachments.splice(index, count);
    }
    editMessage(editing)
    this.setState({messageWrapperHeight : this.calcHeight()}, ()=>{
      this.setState({messageWrapperHeight : this.calcHeight()})
    });
  }

  onChange = (e) => {
    e.stopPropagation();
    const {
      editMessage,
      messages: { editing },
    } = this.props;
    let newmsg = { ...editing };
    newmsg[e.target.name] = e.target.value;
    editMessage(newmsg);
  };

  onReplyChange = (e) => {
    e.stopPropagation();
    const {
      editMessage,
      messages: { editing },
    } = this.props;
    let newmsg = { ...editing };
    newmsg.newChildren[e.target.name] = e.target.value;
    editMessage(newmsg);
  };

  sendReplyMessage = (e, i) => {
    e.stopPropagation();
    const { postMessage } = this.props;
    const {
      editMessage,
      messages: { editing, items },
      removeHistory
    } = this.props;

    let isCFwithNoPermission = this.checkCFAttachmentAndPermission();
    if(isCFwithNoPermission){return;}

    postMessage(
      "savemessage",
      "",
      { message: editing.newChildren },
      (data, error) => {
        if (data?.id) {
          if(editing?.type === messageTypes.CONTENT_REQUEST){
            removeHistory(editing?.id);
          }
          this.setState({ messageSent:true });
          setTimeout(()=>{
            this.setState({ messageSent:false },()=>{
              this.setState({messageWrapperHeight : this.calcHeight()});
            });
          }, 1500)
          // let newEditing = { ...editing };
          let newEditing = deepCopyFunction(editing);
          newEditing.newChildren.id = data.id;
          if (!newEditing.children) newEditing.children = [];
          newEditing.children.push({ ...newEditing.newChildren });
          newEditing.newChildren = _newReply(newEditing, "");
          let index = items.findIndex((v) => v.id === editing.id);
          if(index !== -1){
            items.splice(index,1);
            items.unshift(localRefreshTrackingMetaInbox(newEditing))
          }
          editMessage(newEditing);
          this.setState({messageWrapperHeight : this.calcHeight()});
          this.containerEle.scrollTop = this.containerEle.scrollHeight;
        }
      }
    );
  };

  sendMessage = (e) => {
    const {
      postMessage,
      editMessage,
      messages: { editing, onMessageCreated, items, query },
      totalResults,
      setNewCount,
      search,
    } = this.props;

    // let isCFwithNoPermission = this.checkCFAttachmentAndPermission(); // cf share removed for SKY -  ML20-5268
    // if(isCFwithNoPermission){return;}

    postMessage("savemessage", "", { message: editing }, (data, error) => {
      if (data?.id) {
        this.setState({ messageSent:true });
        setTimeout(()=>{
          this.setState({ messageSent:false });
        }, 1500)
        let newEditing = { ...editing };
        newEditing.id = data.id;
        newEditing.newChildren = _newReply(newEditing, "");
        items.unshift(this.getFullMessage(newEditing));
        search({...query});
        setNewCount(totalResults+1);
        editMessage(newEditing);
        this.subscribeToRealTimeUpdate(data.id);
        if (onMessageCreated) {
          onMessageCreated(data.id);
        }
      }
    });
  };

  getFullMessage(message) {
    const { user } = this.props;

    message.orgId = user.credentials.orgID;
    message.parent = null;
    message.seenusers = [user.email];
    message.status = 0;
    return localRefreshTrackingMetaInbox(message, true);
  }

  handleOnChangeRecipients = (event, recipients) => {
    const recipientUserIds = Array.from(recipients.slice().filter((e)=> e.groupingType === recipientGroupType.USER), (e) => e.email.trim());
    // const recipientUserIds = Array.from(recipients.slice().filter((e)=> e.groupingType === recipientGroupType.USER), (e) => e.userId);
    const recipientGroupIds = Array.from(recipients.slice().filter((e)=> e.groupingType === recipientGroupType.GROUP), (e) => e.groupId);
       
    const {
      editMessage,
      messages: { editing },
    } = this.props;
    let newmsg = { ...editing };
    newmsg["tousers"] = recipientUserIds;
    newmsg["togroups"] = recipientGroupIds;
    editMessage(newmsg);
    this.setState({recipientField : ""});
  };

  handleOnChangeReplyRecipients = (event, recipients, i) => {
    const recipientUserIds = Array.from(recipients.slice().filter((e)=> e.groupingType === recipientGroupType.USER), (e) => e.email.trim());
    // const recipientUserIds = Array.from(recipients.slice().filter((e)=> e.groupingType === recipientGroupType.USER), (e) => e.userId);
    const recipientGroupIds = Array.from(recipients.slice().filter((e)=> e.groupingType === recipientGroupType.GROUP), (e) => e.groupId);
    const {
      editMessage,
      messages: { editing },
    } = this.props;
    let newmsg = { ...editing };
    newmsg["tousers"] = recipientUserIds;
    newmsg.newChildren["tousers"] = recipientUserIds;
    newmsg["togroups"] = recipientGroupIds;
    newmsg.newChildren["togroups"] = recipientGroupIds;
    editMessage(newmsg);
    this.setState({replyRecipientField : ""});
  };

  handleOnClickRemoveRecipient = (recipientId, recipientType) => {
    const {
      editMessage,
      messages: { editing },
    } = this.props;
    let recipientIds = (recipientType === recipientGroupType.USER) ? editing?.tousers :  editing?.togroups || [];
    const index = recipientIds.indexOf(recipientId);
    if (index > -1) {
      recipientIds.splice(index, 1);
      editMessage(editing);
    }
  };

  handleOnClickRemoveReplyRecipient = (recipientId, recipientType) => {
    const {
      editMessage,
      messages: { editing },
    } = this.props;
    let newmsg = { ...editing };
    let recipientIds = (recipientType === recipientGroupType.USER) ?  editing?.newChildren.tousers : editing?.newChildren.togroups || [];
    const index = recipientIds.indexOf(recipientId);
    if (index > -1) {
      recipientIds.splice(index, 1);
      if(recipientType === recipientGroupType.USER) newmsg.newChildren["tousers"] = recipientIds;
      else newmsg.newChildren["togroups"] = recipientIds;
      editMessage(newmsg);
    }
  };

  closeComposer = (e) => {
    const { 
      editMessage, 
      messages: { closeMessagePanel }, 
      setUsePopup
    } = this.props;
    editMessage(null);
    setUsePopup(false);
    if(closeMessagePanel)closeMessagePanel(true);
    this.initialized = false;
    if(this.messageSubscripition) this.messageSubscripition();
    if(this.messageGroupSubscripitions.length){
      this.messageGroupSubscripitions.forEach(mSubscripition => {
        mSubscripition();
      });
    }
  };

  handleClose = () => {
    const { editMessage, onClose, open, messages: { closeMessagePanel },setUsePopup} = this.props;
    editMessage(null);
    setUsePopup(false);
    if(open && closeMessagePanel)closeMessagePanel(true);
    onClose();
  };

  onDragOver(event){
    event.preventDefault();
  }

  onDrop(event){
    
    if(!this.canDragDropAttachments()){
      event.preventDefault();
      return;
    }
    const {
      editMessage,
      messages: {
        editing,
      },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
  
        }
      }
    } = this.props;
    let data = event.dataTransfer.getData("row");
    
    if(data){
      let rowData = JSON.parse(data);
      let attachmentData = { }

      switch (rowData.messageType) {
        case attachmentTypes.CLEARANCE_FORM:
        
          // // CF share permission check  // cf share removed for SKY -  ML20-5268
          // if(!this.canShareCF(rowData)){
          //   event.preventDefault();
          //   this.setState({
          //     openCfDropError : true,
          //     cfDropErrorMsg: "No Permission to share"
          //   });
            
          //   setTimeout(() => {
          //     this.setState({
          //       openCfDropError : false,
          //       cfDropErrorMsg: ""
          //     });
          //   }, 2000);

          //   return;
          // }

          //   let att = [];
          //   let isRecepients = false;
          //   if (editing.id) {
          //     att = editing.newChildren.attachments;
          //     isRecepients = editing?.newChildren?.tousers?.length > 0 || editing?.newChildren?.togroups?.length > 0
          //   }else{
          //     att = editing.attachments;
          //     isRecepients = editing?.tousers?.length > 0 || editing?.togroups?.length > 0
          //   }

          //   // limiting number of shareable CFs per message to 1.
          //   let index = att.findIndex(a => a.type === attachmentTypes.CLEARANCE_FORM);
          //   if (index > -1) {
          //     event.preventDefault();
          //     this.setState({
          //       openCfDropError : true,
          //       cfDropErrorMsg: "Only one clearance form can be attached per message."
          //     });
              
          //     setTimeout(() => {
          //       this.setState({
          //         openCfDropError : false,
          //         cfDropErrorMsg: ""
          //       });
          //     }, 2000);
          //     return;
          //   }
           
          attachmentData = {       
            id: rowData.id,
            name: rowData.name,
            tracksCount: rowData.tracksCount,
            artwork: null,
            type : attachmentTypes.CLEARANCE_FORM
          }

          // if(isRecepients){ // cf share removed for SKY -  ML20-5268
          //   this.setState({openCFSharePermissiomPopup : true});
          // }

          break;

        case attachmentTypes.CLEARANCE_TRACK:
          // editing.type = messageTypes.CLEARANCE_TRACK;
          attachmentData = {       
            cfid: rowData.clearanceFormId,
            cfname: rowData.clearanceFormName,
            id: rowData.trackDetails.id,
            title: rowData.trackDetails[trackFields.trackTitle.id],
            artist: rowData.trackDetails[trackFields.performer.id],
            artwork: rowData.trackDetails[trackFields.prodArtworkUrl.id],
            type : attachmentTypes.CLEARANCE_TRACK
          }
          break;

        case attachmentTypes.CLEARANCE_FORM_TRACK:
          if(!rowData.editing){ return; }
          // editing.type = messageTypes.CLEARANCE_TRACK;
          attachmentData = {       
            cfid: rowData.editing.id,
            cfname: rowData.editing.name,
            id: rowData.id,
            title: rowData[trackFields.trackTitle.id],
            artist: rowData[trackFields.performer.id],
            artwork: rowData[trackFields.prodArtworkUrl.id],
            type : attachmentTypes.CLEARANCE_FORM_TRACK
          }
          break;
        case attachmentTypes.TRACK:
          // editing.type = messageTypes.CONTENT;
          attachmentData = {       
            id: rowData.id,
            title: rowData[trackFields.trackTitle.id],
            artist: rowData[trackFields.performer.id],
            artwork: rowData[trackFields.prodArtworkUrl.id],
            type : attachmentTypes.TRACK
          }
          break;

        case attachmentTypes.PLAYLIST:
          // editing.type = messageTypes.TEXT;
          attachmentData = {       
            id: rowData.id,
            name: rowData.name,
            tracksCount: rowData.itemsCount,
            artwork: rowData.artwork,
            type : attachmentTypes.PLAYLIST
          }
          break;
      
        default:
          editing.type = messageTypes.TEXT;
          break;
      }
      if (editing.id) {
        editing.newChildren.attachments.push(attachmentData)
      }else{
        editing.attachments.push(attachmentData);
      }
      editMessage(editing);
      this.setState({messageWrapperHeight : this.calcHeight()}, ()=>{
        this.setState({messageWrapperHeight : this.calcHeight()})
      });
    }
    
  }

  getAriaLabelRemoveRecipientButton = (username, text) => {
    return text.replace("<USERNAME>", username);
  };

  calcHeight = () => {
    // const rect = this.toolWrapper ? this.toolWrapper.getBoundingClientRect() : 0;
    const rect = 0;
    const composerRect = this.composeWrapper ? this.composeWrapper.getBoundingClientRect() : 0;
    // return rect.height + composerRect.height + 75;
    return composerRect.height + 60;
  }

  getcStatusText(status){
    let index  = contentRequestStatusList.findIndex(item => item.id == status);
    if(index != -1){
     return contentRequestStatusList[index].label
    }
    else{
      return 'N/A'
    }
  }

  getcStatusNotSourcedText = (status) =>{
    let index = contentRequestNotSourceReasonsList.findIndex((item) => item.id === status);
    if (index != -1) {
      return contentRequestNotSourceReasonsList[index];
    } else {
      return {label : "", hover : ""};
    }
  }

  getcStatusColor = (status) =>{
    let index = contentRequestStatusList.findIndex((item) => item.id === status);
    if (index != -1) {
      return contentRequestStatusList[index].color;
    } else {
      return null;
    }
  }

  renderChildren = () =>{
    const {
      user,
      messages: {
        editing,
      },
    } = this.props;

    let childrenList = [...editing.children];
    
    if(childrenList?.length){
      let previousMsg = null;
      let combinedChildren = [];
      let bodyMsgList = [];

      childrenList.forEach((m,i) => {

        // if((user.id === (m.createdBy || m.by)) || m.tousers.includes(user.id) || this.getUserGroups(m).length > 0){
          previousMsg = childrenList[i -1];
  
          if(previousMsg && (m.createdBy || m.by) === (previousMsg.createdBy || previousMsg.by) && m.attachments.length === 0 && previousMsg.attachments.length === 0){
            let index = combinedChildren.indexOf(previousMsg);
            bodyMsgList.push(m.body);
            combinedChildren.splice(index,1,m);
          }else{
            bodyMsgList= [m.body];
            combinedChildren.push(m);
          }
          m.bodyMsgList =  bodyMsgList;
        // }
      });

      return combinedChildren;
    }

  }

  canDragDropAttachments = () =>{
    const {
      orgRuntime: {
        runtime: {
          _Messages, _canAddContent
      
        }
      } 
    } = this.props;
    let canDragDrop  = _PermittedContent([_Messages, _canAddContent],[]);
    return canDragDrop;
  }

  handleContentStatusChange = (e)=>{
    const {
      user,
      editMessage,
      updateContentReqStatus,
      messages: {
        editing,
        items
      },
      removeHistory
    } = this.props;

    setTimeout(()=>{
      this.setState({messageWrapperHeight : this.calcHeight()});
    }, 0);
    
    if(e.target.value === contentRequestStatus.NOTSOURCED){ 
      editMessage({...editing, cStatus: e.target.value});
      return; 
    }else{
      editMessage({...editing, cStatus: e.target.value, cStatusNotSourced : null});
    }
    updateContentReqStatus('updatecstatus',{parentID:[editing.id], cStatus:e.target.value},
    (data, error)=>{ 
      removeHistory(editing?.id);
      // if(data?.id){
      //   let newEditing = { ...editing };
      //   let index = items.findIndex((v) => v.id === editing.id);
      //   if(index !== -1){
      //     items.splice(index,1);
      //     items.unshift(localRefreshTrackingMetaInbox(newEditing))
      //   }
      // }
    }
    );
  }

  handleContentNotSourcedReasonChange = (e) => {
    const {
      user,
      editMessage,
      updateContentReqStatus,
      messages: {
        editing,
        items
      },
      removeHistory
    } = this.props;

    editMessage({...editing, cStatusNotSourced : e.target.value});
    updateContentReqStatus('updatecstatus',{parentID:[editing.id], cStatus:contentRequestStatus.NOTSOURCED, cStatusNotSourced : e.target.value},
    (data, error)=>{ 
      removeHistory(editing?.id);
      }
    );
  }

  isContentTeam(recps,userid){   
    let index = recps.findIndex((v) => v.groupId === defaultGroups.CONTENT_GROUP);
    if(index != -1){
      let userFoundIndex = recps[index].users.findIndex((v) => v === userid);
      if(userFoundIndex != -1){
        return true
      }
      else{
        return false
      }
    }
    else{
      return false
    }
   
  }

  handleOnTypeRecipients=(event)=>{
    this.setState({[event.target.name] : event.target.value});
  }

  
    // **** CF SHaring related  - START ****
    canShareCF = (cf) => {
      const { user: { id: userId },
      orgRuntime:{
        runtime:{
          _mlLicensing,
          _mlLicensingCanShareCF,
          _mlLicensingCanShareCFOptions
        }
      } } = this.props;
  
      let cfSharePermission = _PermittedContent([_mlLicensing, _mlLicensingCanShareCF], []) ?? _mlLicensingCanShareCF.default;
  
      switch (cfSharePermission) {
        case _mlLicensingCanShareCFOptions.all.id:
          return true;
        case _mlLicensingCanShareCFOptions.own.id:
          return cf?.createdBy === userId;
        case _mlLicensingCanShareCFOptions.none.id:
        default:
          return false;
      }
    }
  
    getRecipientsForSharing = (type) => {
      const {
        inbox: { allUsers, allGroups, },
        messages: { editing, },
        orgRuntime:{
          runtime:{
            _mlCfSharePermissionOptionsID
          }
        }
      } = this.props;
      let recipients = [];
      let recipientData = [];
      switch (type) {
        case 'groups':
          if (!allGroups.length) break;
  
          if (editing.id) {
            recipientData = editing.newChildren.togroups;
          } else {
            recipientData = editing.togroups;
          }
  
          recipients = allGroups?.filter(g => recipientData.includes(g.groupId))
            ?.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
            ?.map(group => {
              return {
                id: group.groupId,
                name: group.name,
                imageUrl: group.imageUrl,
                grUsers: group.users,
                permission: _mlCfSharePermissionOptionsID.canDownloadNoLimit
              }
            });
          break;
        case 'users':
          if (!allUsers.length) break;
  
          if (editing.id) {
            recipientData = editing.newChildren.tousers;
          } else {
            recipientData = editing.tousers;
          }
  
          recipients = allUsers?.filter(u => recipientData.includes(u.email))
            ?.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
            ?.map(user => {
              return {
                id: user.userId,
                email: user.email,
                name: user.name,
                imageUrl: user.imageUrl,
                permission: _mlCfSharePermissionOptionsID.canDownloadNoLimit
              }
            });
          break;
        default:
          recipients = [];
          break;
      }
      return recipients;
    }
  
    onAddCFPermission = (users, groups) => {
      const {
        messages: {
          editing,
        },
        editMessage
      } = this.props;
      
      const { sendingWithNoCfPermission } = this.state;
  
      let nEditing = { ...editing }
      let attachments = [];
      if (nEditing.id) {
        attachments = nEditing.newChildren.attachments;
      } else {
        attachments = nEditing.attachments;
      }
  
      if (attachments?.length && attachments.find(a => a.type === attachmentTypes.CLEARANCE_FORM)) {
        let nAttachments = attachments.map(a => {
          if (a.type === attachmentTypes.CLEARANCE_FORM) {
            return {
              ...a,
              sharedSettings: {
                users: users,
                groups: groups,
              }
            }
          }
          return a;
        });
  
        if (nEditing.id) {
          nEditing.newChildren.attachments = nAttachments;
        } else {
          nEditing.attachments = nAttachments;
        }
  
        editMessage(nEditing);
        this.setState({ openCFSharePermissiomPopup: false }, () => {
          if(sendingWithNoCfPermission){
            if (nEditing.id) {
              this.sendReplyMessage();
            }else{
              this.sendMessage();
            }
          }
        });
        
      }
    }
  
    getCFNameFromAttachment = () => {
      const { messages: { editing, }, } = this.props;
  
      let att = [];
      if (editing.id) {
        att = editing.newChildren.attachments;
      } else {
        att = editing.attachments;
      }
  
      let cfAtt = att.find(a => a.type === attachmentTypes.CLEARANCE_FORM)
      if (cfAtt) {
        return cfAtt.name;
      }
  
      return '';
    }
  
    onCloseCFSharePermission = () => {
      const {
        messages: {
          editing,
        },
        editMessage
      } = this.props;
  
      let nEditing = { ...editing }
      let attachments = [];
  
      if (nEditing.id) {
        attachments = nEditing.newChildren.attachments;
      } else {
        attachments = nEditing.attachments;
      }
  
      let cfAttIndex = attachments.findIndex(a => a.type === attachmentTypes.CLEARANCE_FORM);
  
      if (cfAttIndex > -1) {
        attachments.splice(cfAttIndex, 1);
      }
  
      if (nEditing.id) {
        nEditing.newChildren.attachments = attachments;
      } else {
        nEditing.attachments = attachments;
      }
  
      this.setState({ openCFSharePermissiomPopup: false }, () => {
        editMessage(nEditing);
      });
    }
  
    checkCFAttachmentAndPermission = ()=>{
      const {
        messages: {
          editing,
        },
      } = this.props;
  
      let nEditing = { ...editing }
      let attachments = [];
  
      if (nEditing.id) {
        attachments = nEditing.newChildren.attachments;
      } else {
        attachments = nEditing.attachments;
      }
  
      let cfAtt = attachments.find(a => a.type === attachmentTypes.CLEARANCE_FORM);
      if(cfAtt){
        if(!cfAtt.sharedSettings || (cfAtt.sharedSettings?.users?.length === 0 && cfAtt.sharedSettings?.groups?.length === 0 )){
          this.setState({ 
            // openCFSharePermissiomPopup: true, // cf share removed for SKY -  ML20-5268
            sendingWithNoCfPermission: true,
           });
          return true;
        }
      }
      
      return false;
    }
    // **** CF SHaring related  - END ****


  render() {
    const {
      open,
      classes,
      orgRuntime,
      messages: {
        editing,
        posting: { busy, errors },
      },
      inbox,
      user: { id: userid, email },
      orgRuntime:{
        runtime:{
          _contentRequest
        }
      }
    } = this.props;

    let msgType = editing.type;

    const { recipientField, replyRecipientField, openCFSharePermissiomPopup, openCfDropError, cfDropErrorMsg } = this.state;

    const selectedRecipients = Array.from(
      (editing?.tousers || []).slice(),
      (e) => {
        return {...inbox.allUsers.filter((user) => user.email === e)[0], groupingType : recipientGroupType.USER}
      }
    ).concat(
      Array.from(
        (editing?.togroups || []).slice(),
        (e) => {
          return {...inbox.allGroups.filter((group) => group.groupId === e)[0], groupingType : recipientGroupType.GROUP}
        }
      )
    );

    const replySelectedRecipients = Array.from(
      (editing?.newChildren?.tousers || []).slice(),
      (e) => {
        return {...inbox.allUsers.filter((user) => user.email === e)[0], groupingType : recipientGroupType.USER}
      }
    ).concat(
      Array.from(
        (editing?.newChildren?.togroups || []).slice(),
        (e) => {
          return {...inbox.allGroups.filter((group) => group.groupId === e)[0], groupingType : recipientGroupType.GROUP}
        }
      )
    );


     return (
      <Translation>{(t, { i18n }) => (
        <>
          { openCfDropError && cfDropErrorMsg &&
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={openCfDropError}
              message={cfDropErrorMsg}
              className={classes.snackbar}
            />
          }

          {openCFSharePermissiomPopup &&
            <CfSharePermission
              open={openCFSharePermissiomPopup}
              close={() => { this.onCloseCFSharePermission() }}
              classes={classes}
              DialogBoxTitle={`Set Permission - ${this.getCFNameFromAttachment()}`}
              addPermission={(users, groups) => {
                this.onAddCFPermission(users, groups);
              }}
              users={this.getRecipientsForSharing("users")}
              groups={this.getRecipientsForSharing("groups")}
              addNewUsers={true}
              orgRuntime={orgRuntime}
            />
          }

          {editing.subject === undefined && busy && <CircularProgress />}
          {editing.subject !== undefined && (
            <div>
              {!editing.id && (
                <>
                  <div className={classes.panelHeader}>
                    {open && 
                    <Button 
                      aria-label = {t("messagesManager.closeComposer")}
                      className={clsx(
                        classes.commonBackButton,
                        classes.buttonCustomSize,
                        classes.globalGrayButton
                      )} onClick={this.closeComposer}><FaAngleLeft />
                    </Button>}

                    <div className={classes.panelHeaderMultiText}>
                      <h2 id="messageHeader">  
                        {/* {editing.subject} */}
                        {t("messagesManager.createNewMessage")}
                      </h2>
                    </div>
                    {!open &&
                      <Button
                        aria-label = {t("messagesManager.closeComposer")}
                        className={clsx(
                          classes.commonTopButton,
                          classes.buttonCustomSize,
                          classes.globalGrayButton
                        )}
                        onClick={this.closeComposer}
                      >
                        <CloseIcon />
                      </Button>
                    }
                    {open &&
                      <Button
                        aria-label = {t("messagesManager.close")}
                        className={clsx(
                          classes.commonTopButton,
                          classes.buttonCustomSize,
                          classes.globalGrayButton
                        )}
                        onClick={this.handleClose}
                      >
                        <CloseIcon />
                      </Button>}

                  </div>


                  <div className={clsx(classes.composeNewMessage)}  >
                    <div className={classes.newMsgwrp}>
                      <InputLabel className={classes.appbarHideLabel}  aria-hidden="true" htmlFor="Recipients" > {t("messagesManager.recipientsAriaLabel")} </InputLabel>
                      <Autocomplete
                        forcePopupIcon={false}
                        open={ recipientField.length > 0 }
                        multiple
                        aria-label = {"Select recipients"}
                        clearText='Clear Recipients'
                        filterSelectedOptions
                        id="Recipients"
                        options={this.state.recipients}
                        groupBy={(option) =>option.groupingType}
                        getOptionLabel={(recipient) => recipient.groupingType == recipientGroupType.USER? getUserNameWithDetails(recipient) : recipient.name}
                        limitTags={2}
                        className={classes.searchDropdownList}
                        value={selectedRecipients}
                        inputValue={recipientField}
                        onClose={()=>{
                          this.setState({recipientField : ""});
                        }}
                        onChange={(event, recipients) =>
                          this.handleOnChangeRecipients(event, recipients)
                        }
                        renderTags={(recipients) =>
                          recipients.map((recipient,i) => (
                            <div title={recipient.groupingType == recipientGroupType.USER? getUserNameWithDetails(recipient) : recipient.name} key={`sendRcp${i}`} className={classes.recipientLabel}>
                              <Avatar
                                alt={recipient.name}
                                src={recipient.imageUrl}
                                className={classes.smallAvatar}
                              ></Avatar>
                              <div>
                                <div className={classes.recipientName}>
                                  {recipient.name}
                                </div>
                              </div>
                              <Button
                                focusable
                                classes={{ root: classes.cancelButtonRoot }}
                                onClick={() =>
                                  this.handleOnClickRemoveRecipient(
                                    recipient.email || recipient.groupId, recipient.groupingType
                                  )
                                }
                                aria-label={this.getAriaLabelRemoveRecipientButton(recipient.name, t("commentsManager.removeRecipientButtonAriaLabelDynamic"))}
                              >
                                <CloseIcon
                                  classes={{ root: classes.closeIconRoot }}
                                />
                              </Button>
                            </div>
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            name="recipientField"
                            placeholder="Recipients"
                            autoFocus={editing?.attachments.length == 0? true : null}
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              'aria-label':"Select recipients"
                            }}
                            onChange={(event) =>
                              this.handleOnTypeRecipients(event)
                            }
                          ></TextField>
                        )}
                        getOptionSelected={(option, value)=> (option.groupingType === recipientGroupType.USER) ? (option.email === value.email) : (option.groupId === value.groupId)}
                      ></Autocomplete>

                    </div>
                      <div className={clsx(classes.composeCreateNew)}
                      onDragOver={(event)=>this.onDragOver(event)}
                      onDrop={(event)=>this.onDrop(event)}
                      >
                        {editing?.attachments.length !== 0 && (
                          <div className={classes.composeAttachment}>
                            {this.renderAttachment(true,[])}
                          </div>
                        )}
                    <div className="composeTextArea">
                        <TextareaAutosize
                          rowsMax={4}
                          autoFocus={editing?.attachments.length !== 0? true : null}
                          name="body"
                          aria-label = {t("messagesManager.messageBody")}
                          placeholder="Message here"
                          value={editing.body}
                          onChange={this.onChange}
                        />
                        <Button
                          className={classes.globalGreenButton}
                          aria-label={t("messagesManager.sendMessage")}
                          onClick={(e)=>{
                            e.stopPropagation();
                            this.sendMessage();
                          }}
                          disabled={busy || !(editing?.body || editing?.attachments.length) || !(editing.tousers.length || editing.togroups.length) || !(msgType = messageTypes.CONTENT_REQUEST && editing?.body) ? true : false}
                        >
                          Send {busy && <CircularProgress />}{" "}
                        </Button>
                    </div>
                      </div>


                  </div>
                </>
              )}
              {editing.id && (
                <>
                  <div className={classes.panelHeader}>
                    {open && 
                      <Button 
                        aria-label = {t("messagesManager.closeComposer")}
                        className={clsx(
                          classes.commonBackButton,
                          classes.buttonCustomSize,
                          classes.globalGrayButton
                        )} onClick={this.closeComposer}><FaAngleLeft />
                      </Button>}
                    <div id="messageHeader" className={classes.panelHeaderMultiText}>
                      {/* {editing.subject} */}
                      {t("messagesManager.replyMessage")}                      
                    </div>

                    {!open && <Button
                      aria-label = {t("messagesManager.closeComposer")}
                      className={clsx(
                        classes.commonTopButton,
                        classes.buttonCustomSize,
                        classes.globalGrayButton
                      )}
                      onClick={this.closeComposer}
                    >
                      <CloseIcon />
                    </Button>}
                    {open &&
                      <Button
                      aria-label = {t("messagesManager.close")}
                        className={clsx(
                          classes.commonTopButton,
                          classes.buttonCustomSize,
                          classes.globalGrayButton
                        )}
                        onClick={this.handleClose}
                      >
                        <CloseIcon />
                      </Button>}
                  </div>

                  <div className={ classes.composeAbsoluteContainer } id="messageContainer" ref={(div) => (this.containerEle = div)} style={{ height: `calc(100% - ${this.state.messageWrapperHeight}px)` }}>
                  <div id="subjectWrapper" className={classes.composeMessageLive} ref={(div) => (this.toolWrapper = div)}>
                    <div className={classes.composeRecipient}>
                      {editing?.attachments.length !== 0 && (
                        <>
                          <div className={classes.composeAttachment}>
                            {this.renderAttachment(false, editing.attachments)}
                          </div>
                          <div></div>
                        </>
                      )}
                       <div  className={classes.messageContentMessage}>
                    <div className={classes.messageContentMessages}>
                      <div>{editing.body}</div>

                      <div className={classes.messagebodyCreatedUserDetails}>
                        <UserDisplay userId={editing.by || editing.createdBy} /> <span><DateTimeRenderer key={editing.id} data={editing.at || editing.createdAt} /></span>
                      </div>
                      </div>
                     {editing.type == messageTypes.CONTENT_REQUEST &&(
                       <>
                        <div 
                          title={this.getcStatusText(editing.cStatus)} 
                          style={{backgroundColor : this.getcStatusColor(editing.cStatus)}}
                          className={clsx(
                            "innerStatus",
                            classes.contentRequestStatus,
                            )}
                          >
                          {this.getcStatusText(editing.cStatus)}
                          </div>
                          
                          {editing.cStatus === contentRequestStatus.NOTSOURCED  && editing.cStatusNotSourced && 
                            <div
                              title={this.getcStatusNotSourcedText(editing.cStatusNotSourced)?.hover} 
                              // style={{backgroundColor : this.getcStatusColor(editing.cStatus)}}
                              className={clsx(
                                "innerStatus",
                                classes.contentRequestStatus,
                              )}
                            >
                              {this.getcStatusNotSourcedText(editing.cStatusNotSourced)?.label}
                            </div>
                          }
                       </>
                     )}
                     </div>
                    </div>
                  </div>
                      { editing.children && editing.children.length !== 0 && this.renderChildren()?.map((m, i)=>(
                        <>
                          <div
                            className={
                              (m.by || m.createdBy) === email
                                ? classes.composeSenderLeft
                                : classes.composeSenderRight
                            }
                          >
                            <div className={classes.msgBodyInner}> {m.bodyMsgList.length !== 0 && m.bodyMsgList.map((msg)=>(
                                <>{ msg && <>{msg}<br/> </>}</>
                              ))} 
                            </div>
                            {m.attachments.length !== 0 && (
                              <div className={classes.composeAttachment}>
                                {this.renderAttachment(false,m.attachments, false)}
                              </div>
                            )}
                            <div className={classes.messagebodyUserDetails}>
                              <UserDisplay userId={m.by || m.createdBy} /> <span><DateTimeRenderer key={m.id} data={m.at || m.createdAt} /></span>
                            </div>
                          </div>
                        </>
                      ))}

                  </div>
                  
                  <div
                    className={clsx(
                      classes.composeNewMessage,
                      classes.composeCreateNewMessage
                    )}
                    ref={(div) => (this.composeWrapper = div)}
                    id="composeWrapper"
                  >
                    <div className={classes.composeNewMessageWrapper}
                      onDragOver={(event)=>this.onDragOver(event)}
                      onDrop={(event)=>this.onDrop(event)} >

                      {editing.newChildren.attachments.length !== 0 && (
                        <div className={clsx(classes.composeAttachment, classes.replyAttachment, classes.minHeightWrapper)}>
                          {this.renderAttachment(true,editing.newChildren.attachments)}
                        </div>
                      )}
         

                      { this.state.messageSent && (<div className={classes.sentNotification} role="alert"><FaCheckCircle/> Message has been sent successfully!</div>) }
                      <InputLabel className={classes.appbarHideLabel}  aria-hidden="true" htmlFor="replyRecipients" > {t("messagesManager.recipientsAriaLabel")} </InputLabel>
                      <Autocomplete
                        forcePopupIcon={false}
                        open={replyRecipientField.length >0}
                        multiple
                        aria-label = {t("messagesManager.recipientsAriaLabel")}
                        filterSelectedOptions
                        id="replyRecipients"
                        options={this.state.recipients}
                        groupBy={(option) =>option.groupingType}
                        getOptionLabel={(recipient) => recipient.groupingType == recipientGroupType.USER? getUserNameWithDetails(recipient) : recipient.name}
                        limitTags={2}
                        className={classes.searchDropdownList}
                        value={replySelectedRecipients}
                        inputValue={replyRecipientField}
                        onClose={()=>{
                          this.setState({replyRecipientField : ""});
                        }}
                        onChange={(event, recipients) =>
                          this.handleOnChangeReplyRecipients(event, recipients)
                        }
                        renderTags={(recipients) =>
                          recipients.map((recipient,i) => (
                            <div title={recipient.groupingType == recipientGroupType.USER? getUserNameWithDetails(recipient) : recipient.name} key={`rsp${i}`} className={classes.recipientLabel}>
                              <Avatar
                                alt={recipient.name}
                                src={recipient.imageUrl}
                                className={classes.smallAvatar}
                              ></Avatar>
                              <div>
                                <div className={classes.recipientName}>
                                  {recipient.name}
                                </div>
                              </div>
                              <Button
                                focusable
                                classes={{
                                  root: classes.cancelButtonRoot,
                                }}
                                onClick={() =>
                                  this.handleOnClickRemoveReplyRecipient(
                                    recipient.email || recipient.groupId, recipient.groupingType
                                  )
                                }
                                aria-label={this.getAriaLabelRemoveRecipientButton(recipient.name, t("commentsManager.removeRecipientButtonAriaLabelDynamic"))}
                              >
                                <CloseIcon
                                  classes={{
                                    root: classes.closeIconRoot,
                                  }}
                                />
                              </Button>
                            </div>
                          ))
                        }
                        renderInput={(params) => (
                          <TextField 
                            name="replyRecipientField"
                            placeholder="Recipients"
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              'aria-label':"Select recipients"
                            }}
                            onChange={(event) =>
                              this.handleOnTypeRecipients(event)
                            }
                          ></TextField> 
                        )}
                        getOptionSelected={(option, value)=> (option.groupingType === recipientGroupType.USER) ? (option.email === value.email) : (option.groupId === value.groupId)}
                      ></Autocomplete>

                      <TextareaAutosize
                        rowsMax={4}
                        name="body"
                        aria-label = {t("messagesManager.messageBody")}
                        autoFocus={true}
                        className={clsx(classes.textAreaMinHeight)}
                        placeholder="Message here"
                        value={editing.newChildren.body}
                        onChange={(e) => this.onReplyChange(e)}
                        ref={(el) => this.textAreaAutoSize = el}
                      />
                      {editing?.type === messageTypes.CONTENT_REQUEST && editing?.cStatus && editing?.cStatus === contentRequestStatus.NOTSOURCED && 
                        <PermittedContent modulePath={_contentRequest}>
                          <div className={classes.newModuleClass}>
                            <Select
                              id="cStatus"
                              key="cStatus"
                              name="cStatus"
                              variant="outlined"
                              inputProps={{
                                id: "cStatus",
                                "aria-labelledby": "cStatus",
                              }}
                              className={classes.sidbarDropdownFull}
                              fullWidth
                              value={editing?.cStatus}
                              onChange={this.handleContentStatusChange}
                            >
                              {contentRequestStatusList.map((opt) => (
                                <MenuItem                               
                                key={opt.id} 
                                value={opt.id}>
                                  {opt.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                        </PermittedContent>
                      }

                    <div className={classes.replyMessageButtonSet}>
                      {editing?.type === messageTypes.CONTENT_REQUEST && (
                        <>
                        <PermittedContent modulePath={_contentRequest}>
                          { editing?.cStatus && editing?.cStatus !== contentRequestStatus.NOTSOURCED &&                         
                            <div>
                              <Select
                                id="cStatus"
                                key="cStatus"
                                name="cStatus"
                                variant="outlined"
                                inputProps={{
                                  id: "cStatus",
                                  "aria-labelledby": "cStatus",
                                }}
                                className={classes.sidbarDropdownFull}
                                fullWidth
                                value={editing?.cStatus}
                                onChange={this.handleContentStatusChange}
                              >
                                {contentRequestStatusList.map((opt) => (
                                  <MenuItem                               
                                  key={opt.id} 
                                  value={opt.id}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                          }
                          { editing?.cStatus && editing?.cStatus === contentRequestStatus.NOTSOURCED && 
                            <div>
                              <Select
                                id="cStatusNotSourced"
                                key="cStatusNotSourced"
                                name="cStatusNotSourced"
                                variant="outlined"
                                inputProps={{
                                  id: "cStatusNotSourced",
                                  "aria-labelledby": "cStatusNotSourced",
                                }}

                                className={classes.sidbarDropdownFull}
                                fullWidth
                                value={editing?.cStatusNotSourced}
                                onChange={this.handleContentNotSourcedReasonChange}
                              >
                                {contentRequestNotSourceReasonsList.map((opt) => (
                                  <MenuItem  key={opt.id}  value={opt.id} title={opt.hover}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                          }
                        </PermittedContent>

                        </>
                      )}
                      <Button
                        className={clsx(classes.globalGreenButton)}
                        aria-label= {t("messagesManager.sendReply")}
                        onClick={(e) => {
                          this.sendReplyMessage(e);
                          this.textAreaAutoSize.focus();
                        }}
                        disabled={
                          busy || !(editing?.newChildren?.body || editing?.newChildren?.attachments.length) || !(editing?.newChildren?.tousers.length || editing?.newChildren?.togroups.length) || (editing?.cStatus === contentRequestStatus.NOTSOURCED && !editing?.cStatusNotSourced)
                            ? true
                            : false
                        }
                      >
                        Reply {busy && <CircularProgress />}{" "}
                      </Button>
                   
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}</Translation>

    );
  }
}
